
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/layout/hero-gruenpflege.kpa`,
      template: `<header class="hero-section box-shadow" 
        style="background-image: linear-gradient(to top, rgba(0, 0, 0, .4) 30%, rgba(0, 0, 0, .2) 100%), url('{{backgroundImage}}');" 
        aria-label="Hero Section"
    >
        <div class="wrapper">
            <div class="hero-area">
                <div class="hero-card">
                    <span if="subheadline" class="subh1 box-shadow" id="hero-subtitle">{{subheadline}}</span>
                    <h1 if="headline" id="hero-headline" class="text-shadow">{{headline}}</h1>
                    <p if="text" class="text-shadow">{{text}}</p>
                    <span if="buttonText">
                        <button if="buttonText" class="btn-cta box-shadow btn1" aria-label="Call to action">{{buttonText}}</button>
                        <button if="buttonText2" class="btn-cta box-shadow btn2" aria-label="Call to action">{{buttonText2}}</button>
                    </span>
                </div>
            </div>
        </div>
    </header>`,
      style: `hero-gruenpflege .hero-section {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  position: relative;
  min-height: 100vh;
  padding: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-blend-mode: multiply; /* multiply color-burn overlay soft-light */
  overflow: hidden;
}
hero-gruenpflege .hero-section .wrapper {
  padding-bottom: 0;
}
hero-gruenpflege .hero-section .wrapper .hero-area {
  position: relative;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  padding-top: 32px;
  padding-bottom: 32px;
}
hero-gruenpflege .hero-section .wrapper .hero-area .hero-card {
  position: relative;
  max-width: 760px;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: flex-start;
  padding: 32px 0 32px 32px;
  gap: 16px;
  border-left: 3px solid #62be6a;
}
hero-gruenpflege .hero-section .wrapper .hero-area .hero-card .subh1 {
  font-size: 0.7rem;
  margin-bottom: 0;
  color: #2c4143;
  display: inline-block;
  width: auto;
  padding: 4px 12px;
  border-radius: 32px;
  background-color: #ffffff;
  font-weight: 700;
}
hero-gruenpflege .hero-section .wrapper .hero-area .hero-card h1, hero-gruenpflege .hero-section .wrapper .hero-area .hero-card p {
  margin: 0;
  padding: 0;
  color: #eeeeee;
}
hero-gruenpflege .hero-section .wrapper .hero-area .hero-card h1 {
  font-size: 3rem;
  display: inline-block;
}
hero-gruenpflege .hero-section .wrapper .hero-area .hero-card p {
  font-size: 1.2rem;
  color: #eeeeee;
  display: block;
}
hero-gruenpflege .hero-section .wrapper .hero-area .hero-card p strong {
  font-size: 1.9rem;
  color: #62be6a;
}
hero-gruenpflege .hero-section .wrapper .hero-area .hero-card span {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
  width: 100%;
}
hero-gruenpflege .hero-section .wrapper .hero-area .hero-card span:empty {
  display: none;
}
hero-gruenpflege .hero-section .wrapper .hero-area .hero-card .btn-cta {
  height: 64px;
  font-weight: 700;
  text-transform: uppercase;
  border-radius: 64px;
  margin-top: 16px;
  font-size: 1rem;
}
hero-gruenpflege .hero-section .wrapper .hero-area .hero-card .btn2 {
  background-color: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
}
hero-gruenpflege .hero-section .wrapper .hero-area .hero-card .btn2:hover {
  background-color: #4a9e51;
}
@media (min-width: 1441px) {
  hero-gruenpflege .hero-section .wrapper .hero-area .hero-card {
    transform: scale(1.6);
    transform-origin: left center;
  }
  hero-gruenpflege .hero-section .wrapper .hero-area .hero-card p + span {
    transform: scale(0.625);
    transform-origin: left top;
  }
}
@media (min-width: 1130px) and (max-width: 1440px) {
  hero-gruenpflege .hero-section .wrapper .hero-area .hero-card {
    transform: scale(1.3);
    transform-origin: left center;
  }
  hero-gruenpflege .hero-section .wrapper .hero-area .hero-card p + span {
    transform: scale(0.7692307692);
    transform-origin: left top;
  }
}
@media (max-width: 576px) {
  hero-gruenpflege .hero-section .wrapper .hero-area .hero-card h1 {
    font-size: 2.1rem;
    color: #ffffff;
    display: inline-block;
  }
  hero-gruenpflege .hero-section .wrapper .hero-area .hero-card p {
    font-size: 1.2rem;
    max-width: 600px;
    color: #eeeeee;
    display: block;
  }
  hero-gruenpflege .hero-section .wrapper .hero-area .hero-card p strong {
    font-size: 1.5rem;
  }
}
@media (max-width: 400px) {
  hero-gruenpflege .hero-section .wrapper .hero-area .hero-card h1 {
    font-size: 1.7rem;
  }
  hero-gruenpflege .hero-section .wrapper .hero-area .hero-card p {
    font-size: 1rem;
  }
  hero-gruenpflege .hero-section .wrapper .hero-area .hero-card strong {
    font-size: 1.3rem;
    color: red;
  }
  hero-gruenpflege .hero-section .wrapper .hero-area .hero-card .btn1 {
    font-size: 1rem;
  }
}
@media (max-width: 330px) {
  hero-gruenpflege .hero-section .wrapper .hero-area .hero-card {
    padding-left: 16px;
  }
}
hero-gruenpflege .hero-section .wrapper .hero-area img.hausmeister {
  position: absolute;
  bottom: 0px;
  right: 0;
  width: 850px;
  transform: translateX(20%);
  height: auto;
}

hero-gruenpflege.small .hero-section {
  min-height: 400px;
  height: 10vh;
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    props: {
        backgroundImage: {
            type: 'string',
            required: true,
        },
        headline: {
            type: String,
            default: "",
        },
        subheadline: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "",
        },
        buttonText: {
            type: String,
            default: "",
        },
        buttonLink: {
            type: String,
            default: "",
        },
        buttonText2: {
            type: String,
            default: "",
        },
        buttonLink2: {
            type: String,
            default: "",
        },
    },
    events: [
        ['click', '.hero-section button.btn1', function (event) {
                event.preventDefault();
                if (this.buttonLink)
                    router.navigate(this.buttonLink);
            }],
        ['click', '.hero-section button.btn2', function (event) {
                event.preventDefault();
                if (this.buttonLink2)
                    router.navigate(this.buttonLink2);
            }],
    ]
};
 })()`
    };
  